export const editPanelTabs = ['info', 'metadata', 'collections'] as const
export type EditPanelTab = (typeof editPanelTabs)[number]
